module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.privacyPreferencesQuestions')
    },
    on: {
      "click": function($event) {
        _vm.model.questions = !_vm.model.questions
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.privacyPreferencesQuestionsExplain')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.questions),
      callback: function($$v) {
        _vm.$set(_vm.model, "questions", $$v)
      },
      expression: "model.questions"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.privacyPreferencesFood')
    },
    on: {
      "click": function($event) {
        _vm.model.food = !_vm.model.food
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.privacyPreferencesFoodExplain')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.food),
      callback: function($$v) {
        _vm.$set(_vm.model, "food", $$v)
      },
      expression: "model.food"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.privacyPreferencesProgress')
    },
    on: {
      "click": function($event) {
        _vm.model.progress = !_vm.model.progress
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.privacyPreferencesProgressExplain')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.progress),
      callback: function($$v) {
        _vm.$set(_vm.model, "progress", $$v)
      },
      expression: "model.progress"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.privacyPreferencesAbout')
    },
    on: {
      "click": function($event) {
        _vm.model.information = !_vm.model.information
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.privacyPreferencesAboutExplain')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.information),
      callback: function($$v) {
        _vm.$set(_vm.model, "information", $$v)
      },
      expression: "model.information"
    }
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91f3a338","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Privacy.vue
// module id = 3815
// module chunks = 1